function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { Driver } from "./core/Driver.mjs";
import { getEnvironment } from "./core/getEnvironment.mjs";
import { Logger } from "./core/Logger.mjs";
import { Plugin } from "./core/Plugin.mjs";
import { Stream } from "./core/Stream.mjs";
export class Bridge {
  constructor(options) {
    _defineProperty(this, "environment", getEnvironment());

    this.logger = new Logger(options === null || options === void 0 ? void 0 : options.logLevel);
    this.driver = options !== null && options !== void 0 && options.dangerouslyInjectDriver ? options.dangerouslyInjectDriver : new Driver(this.logger).install();
    this.stream = new Stream(this.logger, this.driver);
    this.plugin = new Plugin(this.logger, this.driver, this.stream);
  }

  addPlugin(Plugin) {
    const plugin = new Plugin(this.logger, this.driver, this.plugin, this.stream);
    this[plugin.namespace] = plugin;
    return this;
  }

}